// Shared UI constants: status badges + Finnish formatting helpers.
import { FileEdit, Clock, CheckCircle2, ShieldAlert } from "lucide-react";

export const STATUS = {
  Luonnos: {
    label: "Luonnos",
    className: "bg-amber-500/15 text-amber-400 border-amber-500/30",
    Icon: FileEdit,
  },
  "Odottaa hyväksyntää": {
    label: "Odottaa hyväksyntää",
    className: "bg-sky-500/15 text-sky-400 border-sky-500/30",
    Icon: Clock,
  },
  Hyväksytty: {
    label: "Hyväksytty",
    className: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    Icon: CheckCircle2,
  },
  Estetty: {
    label: "Estetty",
    className: "bg-rose-500/15 text-rose-400 border-rose-500/30",
    Icon: ShieldAlert,
  },
};

export const PRIORITY = {
  high: { label: "Korkea", className: "bg-rose-500/15 text-rose-400 border-rose-500/30" },
  medium: { label: "Keskitaso", className: "bg-sky-500/15 text-sky-400 border-sky-500/30" },
  normal: { label: "Keskitaso", className: "bg-sky-500/15 text-sky-400 border-sky-500/30" },
  low: { label: "Matala", className: "bg-slate-500/15 text-slate-400 border-slate-500/30" },
};

export const TASK_STATUS = {
  todo: "Tekemättä",
  doing: "Kesken",
  done: "Valmis",
};

const WEEKDAYS = ["Sunnuntai", "Maanantai", "Tiistai", "Keskiviikko", "Torstai", "Perjantai", "Lauantai"];
const MONTHS = ["tammikuuta", "helmikuuta", "maaliskuuta", "huhtikuuta", "toukokuuta", "kesäkuuta",
  "heinäkuuta", "elokuuta", "syyskuuta", "lokakuuta", "marraskuuta", "joulukuuta"];

export const fiDate = (d) => {
  const date = new Date(d);
  return `${WEEKDAYS[date.getDay()]} ${date.getDate()}. ${MONTHS[date.getMonth()]}`;
};

export const fiTime = (d) =>
  new Date(d).toLocaleTimeString("fi-FI", { hour: "2-digit", minute: "2-digit" });

export const fiDateTime = (d) => `${fiDate(d)} klo ${fiTime(d)}`;

export const fiRelative = (d) => {
  if (!d || !Number.isFinite(new Date(d).getTime())) return "ajankohta tuntematon";
  const diff = (Date.now() - new Date(d).getTime()) / 60000;
  if (diff < 0) return `tulevaisuudessa (${fiDateTime(d)})`;
  if (diff < 1) return "juuri nyt";
  if (diff < 60) return `${Math.round(diff)} min sitten`;
  if (diff < 1440) return `${Math.round(diff / 60)} h sitten`;
  return fiDate(d);
};

export const RECURRENCE = { none: "Kerran", daily: "Päivittäin", weekly: "Viikoittain" };
